import { AgenticBriefDisplayStatus, DmBriefDisplayStatus } from '../gql-operations/gql-generated';

export enum BriefDisplayStatus {
    NO_INVITES_SENT = 'NO_INVITES_SENT',
    LIVE = 'LIVE',
    INACTIVE = 'INACTIVE',
    HIRED = 'HIRED',
    REJECTED = 'REJECTED',
    UNKNOWN = 'UNKNOWN',
    DONE = 'DONE',
    DELETED = 'DELETED',
}

export const gqlDmBriefDisplayStatusToBriefDisplayStatusMap: Record<DmBriefDisplayStatus, BriefDisplayStatus> = {
    [DmBriefDisplayStatus.Done]: BriefDisplayStatus.DONE,
    [DmBriefDisplayStatus.Hired]: BriefDisplayStatus.HIRED,
    [DmBriefDisplayStatus.Inactive]: BriefDisplayStatus.INACTIVE,
    [DmBriefDisplayStatus.Live]: BriefDisplayStatus.LIVE,
    [DmBriefDisplayStatus.NoInvitesSent]: BriefDisplayStatus.NO_INVITES_SENT,
    [DmBriefDisplayStatus.Rejected]: BriefDisplayStatus.REJECTED,
    [DmBriefDisplayStatus.Unknown]: BriefDisplayStatus.UNKNOWN,
};

export const gqlAgenticBriefDisplayStatusToBriefDisplayStatusMap: Record<
    AgenticBriefDisplayStatus,
    BriefDisplayStatus
> = {
    [AgenticBriefDisplayStatus.Inactive]: BriefDisplayStatus.INACTIVE,
    [AgenticBriefDisplayStatus.Live]: BriefDisplayStatus.LIVE,
    [AgenticBriefDisplayStatus.Rejected]: BriefDisplayStatus.REJECTED,
    [AgenticBriefDisplayStatus.Unknown]: BriefDisplayStatus.UNKNOWN,
};

export const INACTIVE_DISPLAY_STATUSES = [
    BriefDisplayStatus.INACTIVE,
    BriefDisplayStatus.REJECTED,
    BriefDisplayStatus.DELETED,
    BriefDisplayStatus.DONE,
];

export const isBriefActive = (status: BriefDisplayStatus) => !INACTIVE_DISPLAY_STATUSES.includes(status);
